import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { HonorariosContent } from './components/HonorariosContent';

export default function AdminHonorarios() {

    return (
        <>
            <MainContent
                component={<HonorariosContent />}
                titulo={'Administración de Honorarios'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
